import React, { useState } from "react"
import { createModel } from "hox";
import { IJournalParams, IJournalDetail, IJournalSearch, ExecType, ExecStatus } from "./dataJournalTypes"
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, defaultMdCmParam } from "../../../utils/constants";
import { TablePaginationConfig } from "antd/es/table/interface";
import { IPgProps, ISearchPage } from "../../../types/FmsTypes";
import { filterArrId, Optios, transPgToPagination } from "../../../utils/utils"

import { journalService } from "./dataJournalService"

const setExecTypeName = (str: string) => {
    switch (str) {
        case ExecType.I: return "新增";
        case ExecType.U: return "修改";
        case ExecType.D: return "删除";
        case ExecType.S: return "查询";
        default: return false;
    }
}
const setExecStatusName = (num: number) => {
    switch (num) {
        case ExecStatus.待审核: return ExecStatus[0];
        case ExecStatus.执行中: return ExecStatus[1];
        case ExecStatus.执行成功: return ExecStatus[2];
        case ExecStatus.执行异常: return ExecStatus[9];
        default: return false;
    }
}
export const useDataJournalModel = createModel(function () {
    const initSearchParams: IJournalParams = {}
    const initDataSource: IJournalDetail[] = []
    const initPage: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    //查询条件
    const [searchParam, setSearchParam] = useState<IJournalParams>(initSearchParams)
    //列表数据
    const [dataSource, setDataSource] = useState<IJournalDetail[]>(initDataSource);
    //分页参数
    const [page, setPage] = useState<TablePaginationConfig>(initPage);
    //表格选中行key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    ////表格选中行的数据
    const [selectedRow, setSelectedRow] = useState<IJournalDetail[]>([])
    const upDataSearchParam = (upDataParam: IJournalParams) => {
        console.log(upDataParam)
        setSearchParam({ ...searchParam, ...upDataParam })
    }
    const resetSearchParam = () => {
        setSearchParam(initSearchParams)
        const resetPage = { pageSize: 15, pageNum: 1 }
        loadData(resetPage, initSearchParams)
    }
    const loadData = async (pages?: ISearchPage, data?: IJournalParams) => {
        const searchParams = data ?? searchParam
        const params = {
            ...searchParams,
            page: {
                pageSize: pages?.pageSize ?? page.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: pages?.pageNum ?? page.current ?? DEFAULT_FIRST_PAGE_NUM
            }
        }
        const { retData } = await journalService.page(params)
        const { records, ...pg } = retData
        setPage(transPgToPagination(pg));
        const newRecords = records.map((item:IJournalDetail)=>{
            return {
                ...item,
                execTypeName:setExecTypeName(item.execType as string),
                execStatusName:setExecStatusName(item.execStatus as number)
            }
        })
        setDataSource(newRecords)
    }
    const reviewCode = async (code: string[]) => {
        let params = {
            ids: code
        }
        const { retData, retMsg } = await journalService.review(params)
        return retData
    }
    return {
        searchParam,
        dataSource,
        page,
        selectedRow,
        selectedRowKeys,
        setSearchParam,
        setDataSource,
        setPage,
        upDataSearchParam,
        resetSearchParam,
        loadData,
        setSelectedRowKeys,
        setSelectedRow,
        reviewCode
    }
});